var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/Core icons/",
    clipPath: "url(#clip0_522_31207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.89265L15.9995 0.793211L15.9881 0.696056L15.966 0.602363L15.94 0.527721L15.8996 0.44195L15.8339 0.339427L15.754 0.247339C15.7071 0.200332 15.6546 0.158824 15.5973 0.123846L15.4947 0.0701495L15.4114 0.0395427L15.356 0.0235475L15.3176 0.0159872L15.2286 0.00292644L15.1579 0H10.1043L10.0061 0.00566476C9.58726 0.0543091 9.26218 0.410243 9.26218 0.842105L9.26784 0.940312C9.31649 1.35912 9.67242 1.68421 10.1043 1.68421L13.1278 1.68404L7.61596 7.19808L7.54593 7.27743C7.28913 7.60783 7.31258 8.0855 7.61621 8.389L7.69556 8.45903C8.02597 8.71583 8.50363 8.69237 8.80713 8.38874L14.316 2.87814L14.3158 5.89265L14.3215 5.99086C14.3701 6.40967 14.7261 6.73476 15.1579 6.73476C15.623 6.73476 16 6.35773 16 5.89265ZM1.68421 4.21055C1.68421 3.28039 2.43826 2.52634 3.36842 2.52634H6.08187C6.54695 2.52634 6.92398 2.14932 6.92398 1.68424C6.92398 1.21915 6.54695 0.842131 6.08187 0.842131H3.36842C1.50809 0.842131 0 2.35022 0 4.21055V12.6316C0 14.4919 1.50809 16 3.36842 16H11.7895C13.6498 16 15.1579 14.4919 15.1579 12.6316V10.6667C15.1579 10.2016 14.7809 9.82459 14.3158 9.82459C13.8507 9.82459 13.4737 10.2016 13.4737 10.6667V12.6316C13.4737 13.5618 12.7196 14.3158 11.7895 14.3158H3.36842C2.43826 14.3158 1.68421 13.5618 1.68421 12.6316V4.21055Z",
    fill: "#0021A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_31207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.4a6e7eba0bac36e11792cec025ae1f88.svg";
export { ForwardRef as ReactComponent };